import React from 'react';
import { Phone } from 'lucide-react';
import './FloatingPhoneButton.css';

const FloatingPhoneButton = ({ phoneNumber }) => {
  return (
    <a 
      href={`tel:${phoneNumber || '+902125550123'}`}
      className="floating-phone-button"
      aria-label="Telefon"
    >
      <div className="phone-button-icon">
        <Phone size={24} />
      </div>
      <div className="phone-button-ripple"></div>
      <div className="phone-button-ripple phone-button-ripple-delay"></div>
    </a>
  );
};

export default FloatingPhoneButton;


